import React, { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { SunSpinner } from '../../sharedComponents/SunSpinner/SunSpinner';
import styles from './auth-redirect.module.scss';

type AuthRedirectProps = {
  screenHint?: 'signup';
};

const AuthRedirect: React.FC<AuthRedirectProps> = ({ screenHint }) => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const redirectStarted = useRef(false);

  useEffect(() => {
    if (redirectStarted.current || isLoading) {
      return;
    }

    redirectStarted.current = true;

    if (isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }

    void loginWithRedirect({
      openUrl: (url): void => window.location.replace(url),
      appState: {
        returnTo: '/',
      },
      authorizationParams: screenHint
        ? {
            screen_hint: screenHint,
          }
        : undefined,
    });
  }, [isAuthenticated, isLoading, loginWithRedirect, navigate, screenHint]);

  return (
    <div className={styles.container} aria-busy="true" aria-live="polite">
      <SunSpinner rays={8} />
    </div>
  );
};

export default AuthRedirect;
